/**
 * Core Layer - Config
 * Environment and configuration utilities
 */

// Raw environment variables (Next.js compatible)
export {
  rawEnv,
  isDevelopment,
  isProduction,
  isTest,
  type RawEnv,
} from "./raw-env";

// Environment parsing utilities
export {
  parseArray,
  parseBoolean,
  parseNumber,
  parseString,
  resolveApiBaseUrl,
  resolveUseLocalBackend,
  type UseLocalBackendSetting,
} from "../utils/env-utils";

// Legacy env validation (for complex validation needs)
export {
  createEnvValidator,
  envSchema,
  type EnvSchema,
  type EnvValidationError,
  type EnvValidationResult,
  type InferEnvConfig,
  type InferEnvType,
} from "./env";
